import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { OptionsTypeSelector } from '../../../../../models/options-type-selector';
import { ITransportConfiguration } from '../../../../../models/transport-configuration.model';
import { Transport } from '../../../../../models/transport.model';

@Component({
  selector: 'jhi-access-constraint',
  templateUrl: './access-constraint.component.html',
  styleUrls: ['./access-constraint.component.scss'],
})
export class AccessConstraintComponent implements OnChanges, OnInit {
  @Input() transport?: Transport;
  @Input() config?: ITransportConfiguration;
  @Input() options: { isPickup: boolean } = { isPickup: true };
  @Input() control = new FormControl('');

  @Output() selectedAccessConstraint = new EventEmitter<string>();

  public accessConstraints: OptionsTypeSelector[] = [];

  public ngOnChanges(changes: SimpleChanges): void {
    for (const change in changes) {
      if (change === 'config') {
        this.filteringOptions(changes['config'].currentValue);
      }
    }
  }

  public ngOnInit(): void {
    this.filteringOptions(this.config);
  }

  filteringOptions(config?: ITransportConfiguration): void {
    if (!config) {
      this.accessConstraints = OptionsTypeSelector.ACCESS_CONSTRAINT;
    } else {
      const accessConstraintValues = OptionsTypeSelector.ACCESS_CONSTRAINT.reduce((values, accessConstraint) => {
        values.push(accessConstraint.value);
        return values;
      }, [] as string[]);

      this.accessConstraints = config.accessConstraints
        .filter(constraint => accessConstraintValues.indexOf(constraint) !== -1)
        .map(constraint => OptionsTypeSelector.ACCESS_CONSTRAINT[accessConstraintValues.indexOf(constraint)]);
    }
    if (!this.control.value) {
      this.selectedAccessConstraint.emit(this.accessConstraints[0].value);
    }
  }

  switchCase<T>(pickupVal: T, deliveryVal: T): T {
    return this.options.isPickup ? pickupVal : deliveryVal;
  }
}
